import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Spinner} from '..';
import {openModal} from '../../actions';
import {useTableSort} from '../../utils/sortUtilities';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'name',
    numeric: false,
    disabledPadding: true,
    label: 'Elevator Name',
  },
  {
    id: 'buildingName',
    numeric: false,
    disabledPadding: false,
    label: 'Building',
  },
  {
    id: 'entranceName',
    numeric: false,
    disabledPadding: false,
    label: 'Entrance',
  },
  {
    id: 'phoneNumber',
    numeric: false,
    disabledPadding: false,
    label: 'Phone number',
  },
  {
    id: 'imei',
    numeric: false,
    disabledPadding: false,
    label: 'IMEI',
  },
  {
    id: 'category',
    numeric: false,
    disabledPadding: false,
    label: 'Category',
  },
  {
    id: 'status',
    numeric: false,
    disabledPadding: false,
    label: 'Status',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: true,
    label: 'Created at',
  },
  {
    id: 'addAction',
    numeric: false,
    disabledPadding: true,
    label: 'Add Action',
  },
  {
    id: 'actions',
    numeric: false,
    disabledPadding: true,
    label: 'View Action',
  },
];

const DATA_CELLS = [
  'name',
  'buildingName',
  'entranceName',
  'phoneNumber',
  'imei',
  'category',
  'status',
  'createdAt',
  'addAction',
  'viewReport',
];

const ElevatorsTable = ({elevators, loading, building}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {user} = useSelector(s => s.user);
  const onRowClick = item => {
    navigate(`/elevators/${item}`);
  };
  const rowHref = item => `/elevators/${item}`;
  const onAdd = () => {
    dispatch(openModal('AddElevatorModal', {building}));
  };
  const tableOrder = useTableSort('asc', 'createdAt');

  if (loading) {
    return <Spinner />;
  }

  // const onAddReport = (elevatorId) => {
  //   navigate(`/services`);
  // };

  const onViewReport = (elevatorId, elevatorDetails) => {
    if (
      elevatorDetails?.category === 'Stairs' ||
      elevatorDetails?.category === 'S'
    ) {
      navigate(`/escalators/view-reports`, {
        state: {elevatorId, elevatorDetails},
      });
    } else {
      navigate(`/elevators/view-reports`, {
        state: {elevatorId, elevatorDetails},
      });
    }
  };

  const onAddReport = (elevatorId, elevatorDetails) => {
    if (
      elevatorDetails?.category === 'Stairs' ||
      elevatorDetails?.category === 'S'
    ) {
      navigate(`/escalators/add-escalator-report`, {
        state: {elevatorId, elevatorDetails},
      });
    } else {
      navigate(`/elevators/add-elevator-report`, {
        state: {elevatorId, elevatorDetails},
      });
    }
  };

  return (
    <Table
      data={elevators}
      dataCells={DATA_CELLS}
      headCells={HEAD_CELLS}
      onRowClick={onRowClick}
      rowHref={rowHref}
      onAdd={
        !!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' ? onAdd : null
      }
      noToolbar={
        !!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' ? false : true
      }
      {...tableOrder}
      onAddReport={elevatorId =>
        onAddReport(
          elevatorId,
          elevators.find(e => e.id === elevatorId),
        )
      }
      onViewReport={elevatorId =>
        onViewReport(
          elevatorId,
          elevators.find(e => e.id === elevatorId),
        )
      }
    />
  );
};

export default ElevatorsTable;
